// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Actions from "../../actions/Creators";
import {
  Layout,
  ToggleButton,
  Loader,
  Button,
  SnackBar
} from "../../components/common/";
import I18n from "../../i18n/I18n";
import styles from "./Settings.scss";
import StoreProfile from "../../components/settings/StoreProfile";
import FbnSettings from "../../components/settings/FbnSettings";
import Helper from "../../helper/Helper";
import WareHouseCards from "../../components/settings/WareHouseCards";
import UsersCard from "../../components/settings/UsersCard";
import UploadView from "../../components/settings/uploadView/UploadView";
import Preview from "../../components/settings/uploadView/Preview";
import Notification from "../../components/settings/Notification";

type State = {
  settingsType: Number,
  userType: Number,
  prefNotOption: Number,
  showBar: boolean
};

class Settings extends Component<void, State> {
  state = {
    resetProcessForAll: false,
    settingsType: 1,
    prefNotOption: "1",
    prefLanguage: "",
    userType: 1,
    importError: "",
    importSuccess: "",
    prefNotOptionWarehouse: [],
    prefProcOptionWarehouse: [],
    prefLanguageWarehouse: [],
    showBar: false,
    payload: []
  };

  componentDidMount = () => {
    this.props.dispatch(Actions.getVatInfo());
    this.getPreferencesList();
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (
      this.props.preferences &&
      this.props.preferences !== prevProps.preferences &&
      this.props.preferences.notification_preferences
    ) {
      this.setState({
        prefNotOption: this.props.preferences.notification_preferences
          .notification_frequency_code,
        prefLanguage: this.props.preferences.notification_preferences
          .language_code
      });
    }
    if (
      this.props.wareHouses &&
      this.props.wareHouses !== prevProps.wareHouses &&
      this.props.wareHouses.warehouses
    ) {
      const prefNotOptionWarehouse = [];
      const prefProcOptionWarehouse = [];
      for (let i = 0; i < this.props.wareHouses.warehouses.length; i++) {
        prefNotOptionWarehouse[i] = this.props.wareHouses.warehouses[
          i
        ].notification_preference_code;
        prefProcOptionWarehouse[i] = this.props.wareHouses.warehouses[
          i
        ].id_processing_time;
      }
      this.setState({
        prefNotOptionWarehouse,
        prefProcOptionWarehouse,
        resetProcessForAll: false
      });
    }
  };

  // toggling settings tab
  toggleSettings = settingsType => {
    if (settingsType === 3) {
      this.getWareHouses();
      this.setFalse();
    } else if (settingsType === 1) {
      this.getVatInfo();
      this.setFalse();
    } else if (settingsType === 4) {
      this.getPreferencesList();
      this.setFalse();
    } else if (settingsType === 5) {
      this.getFbnPreferences();
      this.setFalse();
    }
    this.setState({
      settingsType
    });
  };

  // Setting snackbar state to false ==> unless it will create problem in switching tabs
  setFalse = () => {
    this.setState({
      showBar: false
    });
  };

  // toggling users inner tab
  toggleUsers(userType) {
    if (userType === 2) {
      this.getUsers();
    }
    this.setState({
      userType
    });
  }

  // getting all the warehouses
  getWareHouses() {
    this.props.dispatch(Actions.getWareHouses());
  }

  // GETTING NOTIFICATION AND LANGUAGE PREFERENCES
  getPreferencesList = () => {
    this.props.dispatch(Actions.getNotificationPreference());
  };

  // getting vat info
  getVatInfo() {
    this.props.dispatch(Actions.getVatInfo());
  }

  // getting all the users
  getUsers() {
    this.props.dispatch(Actions.getUsersList());
  }

  // getting Fbn preferences
  getFbnPreferences() {
    this.props.dispatch(Actions.getFbnSettings());
  }

  // Post API call for submitting FBN settings
  postFbnPreferences = force => {
    let payload = {
      is_accept_fbntc: 1
    };

    if (force) {
      payload = {
        is_optin_fbn: 1
      };
    }
    this.props.dispatch(Actions.changeFbnSettings(payload));
  };
  toggleResetProcessTimeForAll = index => {
    const newState = this.state;
    this.setState({ resetProcessForAll: !newState.resetProcessForAll }, () => {
      console.log("toggle", this.state.resetProcessForAll);
      const processingTime =
        newState.prefProcOptionWarehouse &&
        newState.prefProcOptionWarehouse[index];
      const payload = {
        id_processing_time: processingTime,
        is_reset_processing_time: this.state.resetProcessForAll ? 1 : 0
      };
      this.onDropDownChangeWarehouse(payload, "resetProcessingTime", index);
    });
  };

  onDropDownChangeWarehouse = (e, key, index) => {
    console.log("onDropDownChangeWarehouse", e.value);
    const newState = this.state;
    if (key !== "resetProcessingTime") newState[key][index] = e.value;
    const wId =
      this.props.wareHouses &&
      this.props.wareHouses.warehouses &&
      this.props.wareHouses.warehouses[index] &&
      this.props.wareHouses.warehouses[index].id_warehouse;

    const payload = {
      id_warehouse: wId
    };

    if (key === "prefNotOptionWarehouse") {
      payload.notification_frequency_code = e.value;
    }
    if (key === "prefLanguageWarehouse") {
      payload.language_code = e.value;
    }
    if (key === "prefProcOptionWarehouse") {
      payload.is_reset_processing_time = this.state.resetProcessForAll ? 1 : 0;
      payload.id_processing_time = e.value;
    }
    if (key === "resetProcessingTime") {
      payload.is_reset_processing_time = e.is_reset_processing_time;
      payload.id_processing_time = e.id_processing_time;
    }

    const match = newState.payload.find(
      eachPayload =>
        eachPayload && eachPayload.id_warehouse === payload.id_warehouse
    );
    if (match) {
      newState.payload.splice(newState.payload.indexOf(match), 1);
    }

    newState.payload.push(payload);

    this.setState({
      showBar: !_.isEmpty(newState.payload),
      newState
    });
  };

  // Notification and language preference change
  onDropDownChange = (e, key) => {
    const newState = {};
    newState[key] = e.value;
    this.setState(newState);
  };

  // Partner Level
  onPrefSubmit = values => {
    const payload = {
      notification_frequency_code: this.state.prefNotOption,
      language_code: this.state.prefLanguage
    };
    this.props.dispatch(Actions.postPreference(payload));
  };

  // Warehouse Level
  onPrefSubmitWareHouse = val => {
    const payload = {
      id_partner_warehouses: val
    };
    this.props.dispatch(Actions.postPreference(payload));
    this.toggleBar();
  };

  toggleBar = () => {
    this.setState(prevState => ({
      showBar: !prevState.showBar
    }));
  };

  render() {
    const { showBar } = this.state;
    const seller = this.props.seller;
    const user = this.props.user;
    const wareHouses = this.props.wareHouses;
    const vatInfo = this.props.vatInfo;
    const usersList = this.props.usersList;
    const isWareHousesLoading = this.props.isWareHousesLoading;
    const isUsersLoading = this.props.isUsersLoading;
    const postLoading = this.props.postLoading;
    const fbnSetting = this.props.fbnSettings
      ? this.props.fbnSettings.partner_fbn_settings
      : "";
    const isPreferenceLoading = this.props.preferenceLoading;
    const notifPrefList = this.props.preferences
      ? this.props.preferences.notification_frequency_list
      : "";
    const processPrefList = this.props.preferences
      ? this.props.preferences.processing_time_list
      : "";
    const langList = this.props.preferences
      ? this.props.preferences.language_list
      : "";

    //Mapping API response in react select for Language preference
    let langOptions = [];

    if (langList) {
      for (let i = 0; i < langList.length; i++) {
        const langItem = [];
        langItem.label = langList[i].name;
        langItem.value = langList[i].code;

        langOptions.push(langItem);
      }
    }

    //Mapping API response in react select for Notification preference
    let notfOptions = [];

    if (notifPrefList) {
      for (let i = 0; i < notifPrefList.length; i++) {
        const prefItem = {};
        prefItem.label = notifPrefList[i][`name_${Helper.getLang() || "en"}`];
        prefItem.value = notifPrefList[i].code;

        notfOptions.push(prefItem);
      }
    }

    let processOptions = [];

    if (processPrefList) {
      for (let i = 0; i < processPrefList.length; i++) {
        const prefItem = {};
        prefItem.label = processPrefList[i][`name_${Helper.getLang() || "en"}`];
        prefItem.value = processPrefList[i].id_processing_time;

        processOptions.push(prefItem);
      }
    }

    const wareHouseCards =
      wareHouses && wareHouses.warehouses && !_.isEmpty(wareHouses.warehouses)
        ? wareHouses.warehouses.map((item, index) => {
            return (
              <div key={index} className={styles.eachWarehouse}>
                <WareHouseCards
                  data={item}
                  langSelected={this.state.prefLanguageWarehouse[index]}
                  notfSelected={this.state.prefNotOptionWarehouse[index]}
                  processSelected={this.state.prefProcOptionWarehouse[index]}
                  resetProcessForAll={this.state.resetProcessForAll}
                  toggleResetForAll={this.toggleResetProcessTimeForAll}
                  lang={langOptions}
                  index={index}
                  notPref={notfOptions}
                  processPref={processOptions}
                  onChange={this.onDropDownChangeWarehouse}
                  // onPrefSubmitWareHouse={
                  //     this.onPrefSubmitWareHouse
                  // }
                  postLoading={postLoading}
                />
              </div>
            );
          })
        : "";

    const usersCard =
      usersList && usersList.users && !_.isEmpty(usersList.users)
        ? usersList.users.map((item, index) => {
            return (
              <div key={index} className={styles.eachWarehouse}>
                <UsersCard data={item} />
              </div>
            );
          })
        : "";

    const vat = (
      <div className={styles.vatWrapper}>
        {vatInfo &&
        vatInfo.vat &&
        vatInfo.vat[0] &&
        vatInfo.vat[0].document_path ? (
          <div className={styles.preview}>
            <Preview vatFile={vatInfo.vat[0].document_path} />
          </div>
        ) : (
          ""
        )}
        <div className={styles.uploadCtr}>
          <UploadView vatNumber={vatInfo ? vatInfo.vat["0"].vatin : ""} />
        </div>
      </div>
    );

    const tabs = (
      <div>
        <div className={styles.tabWrapper}>
          <div
            className={`${this.state.userType === 1 ? styles.selected : ""} ${
              styles.tabtitle
            }`}
            onClick={() => this.toggleUsers(1)}
          >
            {I18n.getText("settings.user-details-tab", {}, "User Details")}
          </div>
          <div
            className={`${this.state.userType === 2 ? styles.selected : ""} ${
              styles.tabtitle
            }`}
            onClick={() => this.toggleUsers(2)}
          >
            {I18n.getText("settings.user-list-tab", {}, "User List")}
          </div>
        </div>
      </div>
    );

    const storeProfile = (
      <div>
        <StoreProfile seller={seller} user={user} />
      </div>
    );

    const notification = (
      <div>
        <Notification
          lang={langOptions}
          notPref={notfOptions}
          onChange={this.onDropDownChange}
          langSelected={this.state.prefLanguage}
          notfSelected={this.state.prefNotOption}
          onPrefSubmit={this.onPrefSubmit}
          postLoading={postLoading}
          isPreferenceLoading={isPreferenceLoading}
        />
      </div>
    );
    const fbn = (
      <div>
        <FbnSettings
          data={fbnSetting}
          isLoading={this.props.fbnSettingsLoading}
          post={this.postFbnPreferences}
        />
      </div>
    );

    let renderTab = <div>{vat}</div>;

    switch (this.state.settingsType) {
      case 1:
        renderTab = <div>{vat}</div>;
        break;
      case 2:
        if (user && seller) {
          renderTab = (
            <div>
              {tabs}
              {this.state.userType === 1 ? (
                storeProfile
              ) : (
                <div className={styles.warehouseCtr}>
                  {isUsersLoading ? <Loader /> : usersCard}
                </div>
              )}
            </div>
          );
        }
        break;
      case 3:
        renderTab = <div className={styles.warehouseCtr}>{wareHouseCards}</div>;
        break;
      case 4:
        renderTab = (
          <div className={styles.notificationWrapper}>
            <div className={styles.title}>
              {I18n.getText(
                "settings.pref-title",
                {},
                "Stock Request Email Preferences"
              )}
            </div>
            {notification}
          </div>
        );
        break;
      case 5:
        renderTab = <div>{fbn}</div>;
        break;
      default:
        renderTab = <div>{vat}</div>;
    }

    return (
      <Layout currentIndex={6} title={"settings.title"}>
        <div className={styles.settingsCtr}>
          <div className={styles.topWrapper}>
            <ToggleButton
              toggleBtn={this.toggleSettings}
              toggleItems={[
                I18n.getText("settings.vat"),
                I18n.getText("settings.user-details"),
                I18n.getText("settings.warehouse"),
                I18n.getText("settings.notification"),
                "FBN Settings"
              ]}
              selected={this.state.settingsType}
            />
          </div>

          {isWareHousesLoading ? <Loader /> : renderTab}

          {/* showing snackbar if user change notification preference */}
          {showBar ? (
            <SnackBar
              postLoading={postLoading}
              toggleBar={this.toggleBar}
              onPrefSubmitWareHouse={() =>
                this.onPrefSubmitWareHouse(this.state.payload)
              }
            />
          ) : (
            ""
          )}
        </div>
      </Layout>
    );
  }
}
const mapStateToProps = state => {
  return {
    lang: state.locale.lang,
    user: state.session.user,
    isUsersLoading: state.session.isUsersLoading,
    usersList: state.session.users,
    wareHouses: state.session.wareHouses,
    vatInfo: state.session.vat,
    seller: state.session.seller,
    isLoading: state.session.isLoading,
    isWareHousesLoading: state.session.isWareHousesLoading,
    browser: state.browser,
    preferences: state.session.notificationPreference,
    postLoading: state.session.isPostPreferenceloading,
    preferenceLoading: state.session.isPreferenceLoading,
    fbnSettingsLoading: state.session.isFbnSettingsLoading,
    fbnSettings: state.session.fbnSetting
  };
};

export default connect(mapStateToProps)(Settings);



// WEBPACK FOOTER //
// ./src/containers/settings/Settings.js